const sq = {
  // ============================================================
  // COMMON — E përbashkët për të gjithë aplikacionin
  // ============================================================
  common: {
    loading: 'Po ngarkohet...',
    error: 'Gabim',
    save: 'Ruaj',
    cancel: 'Anulo',
    delete: 'Fshi',
    edit: 'Ndrysho',
    create: 'Krijo',
    add: 'Shto',
    remove: 'Hiq',
    close: 'Mbyll',
    confirm: 'Konfirmo',
    apply: 'Zbato',
    reset: 'Rivendos',
    search: 'Kërko',
    filter: 'Filtro',
    clear: 'Pastro',
    back: 'Prapa',
    next: 'Tjetri',
    previous: 'I mëparshëm',
    submit: 'Dërgo',
    update: 'Përditëso',
    refresh: 'Rifresko',
    export: 'Eksporto',
    import: 'Importo',
    download: 'Shkarko',
    upload: 'Ngarko',
    print: 'Printo',
    copy: 'Kopjo',
    yes: 'Po',
    no: 'Jo',
    ok: 'Në rregull',
    done: 'Përfunduar',
    select: 'Zgjidh',
    selectAll: 'Zgjidhi të gjitha',
    deselectAll: 'Hiq zgjedhjen',
    noResults: 'Nuk u gjetën rezultate',
    noData: 'Nuk ka të dhëna të disponueshme',
    required: 'E detyrueshme',
    optional: 'Opsionale',
    actions: 'Veprime',
    details: 'Detaje',
    overview: 'Pasqyrë',
    summary: 'Përmbledhje',
    total: 'Gjithsej',
    all: 'Të gjitha',
    none: 'Asnjë',
    name: 'Emri',
    type: 'Lloji',
    status: 'Gjendja',
    date: 'Data',
    time: 'Ora',
    description: 'Përshkrimi',
    notes: 'Shënime',
    comments: 'Komente',
    category: 'Kategoria',
    priority: 'Prioriteti',
    nation: 'Shteti',
    country: 'Vendi',
    email: 'E-posta',
    phone: 'Telefoni',
    address: 'Adresa',
    location: 'Vendndodhja',
    coordinates: 'Koordinatat',
    latitude: 'Gjerësia gjeografike',
    longitude: 'Gjatësia gjeografike',
    from: 'Nga',
    to: 'Deri',
    createdAt: 'Krijuar',
    updatedAt: 'Përditësuar',
    createdBy: 'Krijuar nga',
    modifiedBy: 'Ndryshuar nga',
    active: 'Aktiv',
    inactive: 'Joaktiv',
    enabled: 'Aktivizuar',
    disabled: 'Çaktivizuar',
    showing: 'Po shfaqet',
    of: 'nga',
    page: 'Faqja',
    perPage: 'për faqe',
    rows: 'rreshta',
    items: 'artikuj',
    results: 'rezultate',
    sortBy: 'Rendit sipas',
    ascending: 'Rritës',
    descending: 'Zbritës',
    viewAll: 'Shiko të gjitha',
    viewDetails: 'Shiko detajet',
    goBack: 'Kthehu',
    learnMore: 'Mëso më shumë',
    seeMore: 'Shiko më shumë',
    showMore: 'Shfaq më shumë',
    showLess: 'Shfaq më pak',
    expandAll: 'Zgjero të gjitha',
    collapseAll: 'Tkurri të gjitha',
    copied: 'U kopjua!',
    saved: 'U ruajt!',
    deleted: 'U fshi!',
    updated: 'U përditësua!',
    created: 'U krijua!',
    success: 'Sukses',
    warning: 'Paralajmërim',
    info: 'Informacion',
    danger: 'Rrezik',
    unknown: 'E panjohur',
    notAvailable: 'Nuk disponohet',
    never: 'Kurrë',
    today: 'Sot',
    yesterday: 'Dje',
    tomorrow: 'Nesër',
    now: 'Tani',
    ago: 'më parë',
    justNow: 'pikërisht tani',
    minutesAgo: '{{count}} min më parë',
    hoursAgo: '{{count}} orë më parë',
    daysAgo: '{{count}} ditë më parë',
    monthsAgo: '{{count}} muaj më parë',
    id: 'ID',
    version: 'Versioni',
    language: 'Gjuha',
    theme: 'Tema',
    darkMode: 'Mënyra e errët',
    lightMode: 'Mënyra e ndritshme',
    failedToLoad: 'Ngarkimi i të dhënave dështoi',
    failedToSave: 'Ruajtja dështoi',
    failedToDelete: 'Fshirja dështoi',
    failedToUpdate: 'Përditësimi dështoi',
    confirmDelete: 'A jeni i sigurt që dëshironi ta fshini këtë?',
    confirmAction: 'A jeni i sigurt?',
    unsavedChanges: 'Keni ndryshime të paruajtura. A jeni i sigurt që dëshironi të largoheni?',
    pageNotFound: '404 - Faqja nuk u gjet',
    pageNotFoundDesc: 'Faqja që po kërkoni nuk ekziston.',
    backToDashboard: 'Kthehu te paneli kryesor',
    characters: 'karaktere',
    maxCharacters: 'Maksimumi {{max}} karaktere',
    remaining: '{{count}} të mbetura',
    selected: '{{count}} të zgjedhura',
    of_total: '{{count}} nga {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Koka, paneli anësor, menutë
  // ============================================================
  nav: {
    dashboard: 'Paneli kryesor',
    requests: 'Kërkesat',
    transports: 'Transportet',
    myPatients: 'Pacientët e mi',
    statistics: 'Statistikat',
    flow: 'Rrjedha',
    resources: 'Resources',
    exercise: 'Ushtrimi',
    administration: 'Administrimi',
    map: 'Harta',
    info: 'Informacione',
    users: 'Përdoruesit',
    assets: 'Mjetet',
    hubs: 'Nyjet',
    treatmentFacilities: 'Institucionet shëndetësore',
    patientImport: 'Importi i pacientëve',
    assetTemplates: 'Shabllonet e mjeteve',
    dayTemplates: 'Shabllonet ditore',
    announcementTicker: 'Shiriti i njoftimeve',
    exerciseStatistics: 'Statistikat e ushtimit',
    settings: 'Cilësimet',
    auditLog: 'Regjistri i auditimit',
    exerciseControl: 'Kontrolli i ushtimit',
    dataSync: 'Sinkronizimi i të dhënave',
    documentation: 'Dokumentacioni',
    support: 'Mbështetja',
    about: 'Rreth sistemit',
    assetContracts: 'Asset Contracts',
    notifications: 'Njoftimet',
    schedules: 'Oraret',
    capacityPlanning: 'Planifikimi i kapacitetit',
    transportPlanning: 'Planifikimi i transportit',
    transportBooking: 'Rezervimi i transportit',
    flowDiagram: 'Diagrami i rrjedhës',
    changePassword: 'Ndrysho fjalëkalimin',
    missions: 'Misionet',
    startPoints: 'Pikat e nisjes',
    hospital: 'Spitali',
  },

  // ============================================================
  // AUTH — Hyrja, fjalëkalimi, sesioni
  // ============================================================
  auth: {
    login: 'Hyr',
    logout: 'Dil',
    logoutNow: 'Dil tani',
    loggingIn: 'Po hyhet...',
    loginFailed: 'Hyrja dështoi',
    email: 'E-posta',
    password: 'Fjalëkalimi',
    username: 'Emri i përdoruesit',
    enterEmail: 'Vendosni adresën tuaj të e-postës',
    enterPassword: 'Vendosni fjalëkalimin tuaj',
    enterUsername: 'Vendosni emrin tuaj të përdoruesit',
    forgotPassword: 'Keni harruar fjalëkalimin?',
    forgotPasswordTitle: 'Fjalëkalim i harruar',
    forgotPasswordDesc: 'Vendosni emrin tuaj të përdoruesit dhe adresën e e-postës. Nëse të dyja përputhen, administratorët do të njoftohen për rivendosjen e fjalëkalimit tuaj.',
    requestPasswordReset: 'Kërko rivendosjen e fjalëkalimit',
    sending: 'Po dërgohet...',
    backToLogin: 'Kthehu te hyrja',
    pleaseWait: 'Ju lutem prisni para se të provoni përsëri.',
    requestFailed: 'Kërkesa dështoi',
    credentialsMatch: 'Nëse kredencialet përputhen, administratorët janë njoftuar.',
    forAccess: 'Për qasje, ju lutem kontaktoni administratorin e sistemit.',
    changePassword: 'Ndrysho fjalëkalimin',
    currentPassword: 'Fjalëkalimi aktual',
    newPassword: 'Fjalëkalimi i ri',
    confirmPassword: 'Konfirmo fjalëkalimin',
    passwordChanged: 'Fjalëkalimi u ndryshua me sukses',
    passwordMismatch: 'Fjalëkalimet nuk përputhen',
    passwordTooShort: 'Fjalëkalimi duhet të ketë të paktën 8 karaktere',
    changingPassword: 'Po ndryshohet...',
    mustChangePassword: 'Duhet të ndryshoni fjalëkalimin tuaj para se të vazhdoni.',
    sessionExpiring: 'Sesioni po skadon',
    sessionExpireText: 'Sesioni juaj do të skadojë për <strong>{{time}}</strong>. Ju lutem ruani punën tuaj dhe hyni përsëri.',
    dismiss: 'Hiq',
    switchNation: 'Ndrysho shtetin',
    returnTo: 'Kthehu te {{nation}}',
    viewingAs: 'Po shikoni si',
    loggedInAs: 'i hyrë si {{nation}}',
    trainingMode: 'VETËM PËR QËLLIME STËRVITJEJE',
    dedication: 'Krijuar me dashuri dhe përkushtim ndaj profesionit',
  },

  // ============================================================
  // ROLES — Rolet e përdoruesve dhe etiketat
  // ============================================================
  roles: {
    admin: 'Administrator i sistemit',
    excon: 'Kontrollues i ushtimit',
    eu: 'Koordinator i BE-së',
    planner: 'Planifikues',
    hub: 'Menaxher i nyjes',
    nation: 'Shteti',
    readOnly: 'Vetëm lexim',
    systemAdmin: 'Administrator i sistemit',
    transportPlanner: 'Planifikues i transportit',
    systemRoles: 'Rolet e sistemit',
  },

  // ============================================================
  // STATUS — Gjendjet e kërkesave, ofertave, misioneve
  // ============================================================
  status: {
    draft: 'Draft',
    underReview: 'Në shqyrtim',
    published: 'Publikuar',
    underSelection: 'Në përzgjedhje',
    accepted: 'Pranuar',
    planned: 'Planifikuar',
    inTransit: 'Në transport',
    completed: 'Përfunduar',
    closed: 'Mbyllur',
    withdrawn: 'Tërhequr',
    pending: 'Në pritje',
    rejected: 'Refuzuar',
    cancelled: 'Anuluar',
    active: 'Aktiv',
    inactive: 'Joaktiv',
    review: 'Shqyrtim',
    selection: 'Përzgjedhje',
    transit: 'Transport',
  },

  // ============================================================
  // CATEGORIES — Kategoritë e kërkesave
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personeli',
    material: 'Materiali',
    equipment: 'Pajisjet',
    other: 'Tjetër',
    news: 'Lajme',
  },

  // ============================================================
  // URGENCY — Nivelet e urgjencës
  // ============================================================
  urgency: {
    routine: 'Rutinë',
    priority: 'Prioritare',
    urgent: 'Urgjente',
    immediate: 'E menjëhershme',
  },

  // ============================================================
  // ASSETS — Llojet e mjeteve të transportit
  // ============================================================
  assetTypes: {
    train: 'Tren',
    ship: 'Anije',
    aircraft: 'Avion',
    bus: 'Autobus',
    ambulance: 'Ambulancë',
    drone: 'Dron',
    helicopter: 'Helikopter',
    ferry: 'Traget',
    other: 'Tjetër',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Paneli kryesor',
    goodMorning: 'Mirëmëngjes',
    goodAfternoon: 'Mirëdita',
    goodEvening: 'Mirëmbrëmje',
    lastLogin: 'Hyrja e fundit',
    infrastructure: 'Infrastruktura',
    transportAssets: 'Mjetet e transportit',
    treatmentFacilities: 'Institucionet shëndetësore',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Statistikat e kërkesave',
    viewAllRequests: 'Shiko të gjitha kërkesat',
    availableAssets: 'Mjetet e disponueshme',
    seated: 'Ulur',
    lying: 'Shtrirë',
    intensive: 'Intensiv',
    notifications: 'Njoftimet',
    markAllRead: 'Shëno të gjitha si të lexuara',
    noNotifications: 'Ende nuk ka njoftime',
    notifiedWhenActivity: 'Do të njoftoheni kur të ndodhë aktivitet i ri',
    viewDetailsBtn: 'Shiko detajet',
    nationUsers: 'Përdoruesit e shtetit',
    user: 'Përdoruesi',
    roles: 'Rolet',
    noUsersFound: 'Nuk u gjetën përdorues',
    participatingNations: 'Shtetet pjesëmarrëse',
    exerciseDisclaimer: 'Ky sistem është vetëm për përdorim në ushtrime. Vendosni ekskluzivisht të dhëna të simuluara ushtimi. Rrjedhat e punës janë përshtatur sipas skenarit të ushtimit dhe mund të ndryshojnë nga procedurat reale. Rregullat e sigurisë IT dhe mbrojtjes së të dhënave mbeten plotësisht të zbatueshme.',
    notConfigured: 'Nuk është konfiguruar',
    requestCount: '{{count}} kërkesë(a)',
    clickToView: 'Klikoni për të parë',
    systemAdministration: 'Administrimi i sistemit',
    exerciseControlTitle: 'Kontrolli i ushtimit',
    euCoordination: 'Koordinimi i BE-së',
    transportPlanningTitle: 'Planifikimi i transportit',
    hubManagement: 'Menaxhimi i nyjeve',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Kërkesë e re',
    myDrafts: 'Draftet e mia',
    pendingReview: 'Në pritje të shqyrtimit',
    activeTransports: 'Transportet aktive',
    myPatients: 'Pacientët e mi',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Kërkesat',
    newRequest: 'Kërkesë e re',
    createRequest: 'Krijo kërkesë',
    editRequest: 'Ndrysho kërkesën',
    requestDetail: 'Detajet e kërkesës',
    requestId: 'ID e kërkesës',
    fromNation: 'Nga shteti',
    toNation: 'Për shtetin',
    requestingNation: 'Shteti kërkues',
    receivingNation: 'Shteti pranues',
    category: 'Kategoria',
    urgency: 'Urgjenca',
    status: 'Gjendja',
    patients: 'Pacientët',
    patientCount: 'Numri i pacientëve',
    offers: 'Ofertat',
    offerCount: 'Numri i ofertave',
    created: 'Krijuar',
    updated: 'Përditësuar',
    submittedBy: 'Dorëzuar nga',
    reviewedBy: 'Shqyrtuar nga',
    description: 'Përshkrimi',
    medicalDetails: 'Detajet mjekësore',
    transportDetails: 'Detajet e transportit',
    additionalInfo: 'Informacione shtesë',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Pika e nisjes',
    arrivalPoint: 'Pika e mbërritjes',
    estimatedDeparture: 'Nisja e parashikuar',
    estimatedArrival: 'Mbërritja e parashikuar',
    submitForReview: 'Dërgo për shqyrtim',
    publish: 'Publiko',
    startSelection: 'Fillo përzgjedhjen',
    acceptOffer: 'Prano ofertën',
    markInTransit: 'Shëno si në transport',
    markCompleted: 'Shëno si të përfunduar',
    closeRequest: 'Mbyll kërkesën',
    withdrawRequest: 'Tërhiq kërkesën',
    withdraw: 'Tërhiq',
    revertToDraft: 'Kthe në draft',
    deleteRequest: 'Fshi kërkesën',
    duplicateRequest: 'Dupliko kërkesën',
    createFollowUp: 'Krijo kërkesë të konsoliduar',
    followUpRequest: 'Kërkesë e konsoliduar',
    parentRequest: 'Kërkesa origjinale',
    childRequests: 'Kërkesat e konsoliduara',
    noRequests: 'Nuk u gjetën kërkesa',
    noOffers: 'Ende nuk ka oferta',
    addPatient: 'Shto pacient',
    removePatient: 'Hiq pacientin',
    patientDetails: 'Detajet e pacientit',
    contactPerson: 'Personi i kontaktit',
    contactPhone: 'Telefoni i kontaktit',
    contactEmail: 'E-posta e kontaktit',
    specialRequirements: 'Kërkesat e veçanta',
    medicalEquipment: 'Pajisjet mjekësore',
    accompaniment: 'Shoqërimi',
    timeline: 'Kronologjia',
    history: 'Historia',
    addComment: 'Shto koment',
    writeComment: 'Shkruani një koment...',
    postComment: 'Posto komentin',
    posting: 'Po postohet...',
    noComments: 'Ende nuk ka komente',
    coverageBar: 'Mbulimi',
    covered: 'i mbuluar',
    uncovered: 'i pambuluar',
    filterByStatus: 'Filtro sipas gjendjes',
    filterByCategory: 'Filtro sipas kategorisë',
    filterByNation: 'Filtro sipas shtetit',
    searchRequests: 'Kërko kërkesa...',
    confirmWithdraw: 'A jeni i sigurt që dëshironi të tërhiqni këtë kërkesë?',
    confirmDelete: 'A jeni i sigurt që dëshironi ta fshini këtë kërkesë?',
    confirmPublish: 'A jeni i sigurt që dëshironi ta publikoni këtë kërkesë? Do të jetë e dukshme për të gjithë shtetet.',
    confirmStartSelection: 'A jeni i sigurt që dëshironi të filloni përzgjedhjen? Shtetet do të mund të bëjnë oferta.',
    warningStartSelection: 'Fillimi i përzgjedhjes do ta bëjë këtë kërkesë të dukshme për të gjithë shtetet pjesëmarrëse. Ata do të mund të dorëzojnë oferta për pacientët në këtë kërkesë. Ky veprim nuk mund të kthehet mbrapa.',
    warningMakeOffer: 'Duke dorëzuar këtë ofertë, ju angazhoni shtetin tuaj për të ofruar ndihmën e propozuar. Ky veprim do të njoftojë shtetin kërkues dhe kontrollin e ushtimit.',
    saveDraft: 'Ruaj draftin',
    saving: 'Po ruhet...',
    saveAndSubmit: 'Ruaj dhe dërgo',
    step: 'Hapi {{number}}',
    generalInfo: 'Informacione të përgjithshme',
    patientInfo: 'Informacione për pacientin',
    logisticsInfo: 'Informacione logjistike',
    reviewSubmit: 'Shqyrto dhe dërgo',
    requestTitle: 'Titulli i kërkesës',
    requestDescription: 'Përshkrimi i kërkesës',
    numberOfPatients: 'Numri i pacientëve',
    typeOfAssistance: 'Lloji i ndihmës',
    medicalTreatment: 'Trajtimi mjekësor',
    transportAssistance: 'Ndihma për transport',
    both: 'Të dyja',
    treatmentOnly: 'Vetëm trajtim',
    transportOnly: 'Vetëm transport',
    validationErrors: 'Ju lutem korrigjoni gabimet e mëposhtme:',
    fieldRequired: 'Kjo fushë është e detyrueshme',
    selectExitHub: 'Zgjidhni një nyje dalëse',
    createExitHub: 'Krijo nyje dalëse',
    backToRequests: 'Kthehu te kërkesat',
    noRequestsFound: 'Nuk u gjetën kërkesa',
    createFirstRequest: 'Krijoni kërkesën tuaj të parë për të filluar',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Ofertat',
    createOffer: 'Krijo ofertë',
    makeOffer: 'Bëj ofertë',
    manageOffers: 'Menaxho ofertat',
    offerDetail: 'Detajet e ofertës',
    offerId: 'ID e ofertës',
    offeringNation: 'Shteti ofertues',
    offerType: 'Lloji i ofertës',
    treatment: 'Trajtim',
    transport: 'Transport',
    combined: 'I kombinuar',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Ofertë trajtimi',
    transportOffer: 'Ofertë transporti',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Zgjidh pacientët',
    selectedPatients: 'Pacientët e zgjedhur',
    patientSelection: 'Përzgjedhja e pacientëve',
    offerConfiguration: 'Konfigurimi i ofertës',
    reviewOffer: 'Shqyrto ofertën',
    submitOffer: 'Dorëzo ofertën',
    submitting: 'Po dorëzohet...',
    acceptOffer: 'Prano ofertën',
    rejectOffer: 'Refuzo ofertën',
    withdrawOffer: 'Tërhiq ofertën',
    noOffers: 'Nuk ka oferta të disponueshme',
    noOffer: 'No Offer',
    offerStatus: 'Gjendja e ofertës',
    offerDate: 'Data e ofertës',
    transportAsset: 'Mjeti i transportit',
    departureDate: 'Data e nisjes',
    arrivalDate: 'Data e mbërritjes',
    treatmentFacility: 'Institucioni shëndetësor',
    capacity: 'Kapaciteti',
    availableCapacity: 'Kapaciteti i disponueshëm',
    totalCapacity: 'Kapaciteti total',
    selectAsset: 'Zgjidh mjetin',
    selectFacility: 'Zgjidh institucionin',
    offerNotes: 'Shënimet e ofertës',
    confirmAccept: 'A jeni i sigurt që dëshironi ta pranoni këtë ofertë?',
    confirmReject: 'A jeni i sigurt që dëshironi ta refuzoni këtë ofertë?',
    extendTransport: 'Zgjat transportin',
    transportExtension: 'Zgjatja e transportit',
    comparisonView: 'Pamja krahasuese',
    shortlist: 'Lista e ngushtë',
    addToShortlist: 'Shto në listën e ngushtë',
    removeFromShortlist: 'Hiq nga lista e ngushtë',
    leaveConfirmTitle: 'Të largohem nga kjo faqe?',
    leaveConfirmMessage: 'Keni ndryshime të paruajtura. A jeni i sigurt që dëshironi të largoheni?',
    stayOnPage: 'Qëndro në faqe',
    leavePage: 'Largohu nga faqja',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transportet',
    missionDetail: 'Detajet e transportit',
    missionId: 'ID e transportit',
    missionStatus: 'Gjendja e transportit',
    createMission: 'Krijo transport',
    overview: 'Pasqyrë',
    patientsTab: 'Pacientët',
    transportsTab: 'Segmentet e transportit',
    treatmentTab: 'Trajtimi',
    reviewTab: 'Shqyrtimi',
    departure: 'Nisja',
    arrival: 'Mbërritja',
    origin: 'Origjina',
    destination: 'Destinacioni',
    stops: 'Ndalesat',
    addStop: 'Shto ndalesë',
    removeStop: 'Hiq ndalesën',
    stopName: 'Emri i ndalesës',
    stopType: 'Lloji i ndalesës',
    estimatedTime: 'Koha e parashikuar',
    actualTime: 'Koha reale',
    asset: 'Mjeti',
    driver: 'Shoferi',
    crew: 'Ekuipazhi',
    noMissions: 'Nuk u gjetën transportë',
    completeMission: 'Përfundo transportin',
    cancelMission: 'Anulo transportin',
    startTransport: 'Fillo transportin',
    missionChain: 'Zinxhiri i transportit',
    linkedMissions: 'Transportet e lidhura',
    handover: 'Dorëzimi',
    handoverPoint: 'Pika e dorëzimit',
    pickupPoint: 'Pika e marrjes',
    dropoffPoint: 'Pika e lëshimit',
    searchTransports: 'Kërko transportë...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacientët',
    myPatients: 'Pacientët e mi',
    patientId: 'ID e pacientit',
    firstName: 'Emri',
    lastName: 'Mbiemri',
    dateOfBirth: 'Data e lindjes',
    age: 'Mosha',
    gender: 'Gjinia',
    male: 'Mashkull',
    female: 'Femër',
    other: 'Tjetër',
    nationality: 'Shtetësia',
    diagnosis: 'Diagnoza',
    condition: 'Gjendja',
    stable: 'Stabile',
    critical: 'Kritike',
    serious: 'Serioze',
    treatmentNeeded: 'Trajtimi i nevojshëm',
    allergies: 'Alergjitë',
    medications: 'Barnat',
    bloodType: 'Grupi i gjakut',
    weight: 'Pesha (kg)',
    infectious: 'Infektiv',
    mentalHealth: 'Shëndeti mendor',
    mobility: 'Lëvizshmëria',
    ambulatory: 'Ambulantor',
    wheelchair: 'Karrocë invalide',
    stretcher: 'Barelë',
    intensive: 'Kujdes intensiv',
    oxygenRequired: 'Nevojitet oksigjen',
    ventilator: 'Ventilator',
    medicalEscort: 'Shoqërim mjekësor',
    noPatients: 'Nuk u gjetën pacientë',
    patientDetails: 'Detajet e pacientit',
    medicalHistory: 'Historia mjekësore',
    travelDocuments: 'Dokumentet e udhëtimit',
    passport: 'Pasaporta',
    pseudonymizedId: 'ID e pseudonimizuar',
    sensitiveData: 'Të dhëna të ndjeshme',
    journey: 'Rrugëtimi i pacientit',
    assignedTo: 'Caktuar te',
    currentLocation: 'Vendndodhja aktuale',
    importPatients: 'Importo pacientët',
    exportPatients: 'Eksporto pacientët',
    seated: 'Ulur',
    lying: 'Shtrirë',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Përdoruesit',
    createUser: 'Krijo përdorues',
    editUser: 'Ndrysho përdoruesin',
    deleteUser: 'Fshi përdoruesin',
    username: 'Emri i përdoruesit',
    displayName: 'Emri i shfaqur',
    email: 'E-posta',
    password: 'Fjalëkalimi',
    role: 'Roli',
    roles: 'Rolet',
    nation: 'Shteti',
    active: 'Aktiv',
    lastLogin: 'Hyrja e fundit',
    createdAt: 'Krijuar',
    isNation: 'Shtet',
    isEU: 'BE',
    isAdmin: 'Administrator',
    isExcon: 'EXCON',
    isPlanner: 'Planifikues',
    isHub: 'Nyje',
    isReadOnly: 'Vetëm lexim',
    noUsers: 'Nuk u gjetën përdorues',
    confirmDelete: 'A jeni i sigurt që dëshironi ta fshini këtë përdorues?',
    resetPassword: 'Rivendos fjalëkalimin',
    generatePassword: 'Gjenero fjalëkalim',
    searchUsers: 'Kërko përdorues...',
    userCreated: 'Përdoruesi u krijua me sukses',
    userUpdated: 'Përdoruesi u përditësua me sukses',
    userDeleted: 'Përdoruesi u fshi me sukses',
    selectNation: 'Zgjidhni një shtet',
    mustChangePassword: 'Duhet të ndryshojë fjalëkalimin në hyrjen e ardhshme',
    flagImage: 'Imazhi i flamurit',
    exportUsers: 'Eksporto përdoruesit',
    importUsers: 'Importo përdoruesit',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Mjetet',
    createAsset: 'Krijo mjet',
    editAsset: 'Ndrysho mjetin',
    deleteAsset: 'Fshi mjetin',
    assetName: 'Emri i mjetit',
    assetType: 'Lloji i mjetit',
    capacitySeated: 'Kapaciteti (ulur)',
    capacityLying: 'Kapaciteti (shtrirë)',
    capacityIntensive: 'Kapaciteti (intensiv)',
    owner: 'Pronari',
    operator: 'Operatori',
    baseLocation: 'Vendndodhja bazë',
    range: 'Rrezja',
    speed: 'Shpejtësia',
    noAssets: 'Nuk u gjetën mjete',
    confirmDelete: 'A jeni i sigurt që dëshironi ta fshini këtë mjet?',
    searchAssets: 'Kërko mjete...',
    assetCreated: 'Mjeti u krijua me sukses',
    assetUpdated: 'Mjeti u përditësua me sukses',
    assetDeleted: 'Mjeti u fshi me sukses',
    exportAssets: 'Eksporto mjetet',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Nyjet',
    startPoints: 'Pikat e nisjes',
    createHub: 'Krijo nyje',
    editHub: 'Ndrysho nyjen',
    deleteHub: 'Fshi nyjen',
    hubName: 'Emri i nyjes',
    hubType: 'Lloji i nyjes',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Nyja e hyrjes',
    airport: 'Aeroporti',
    seaport: 'Porti detar',
    railStation: 'Stacioni hekurudhor',
    roadPoint: 'Pika rrugore',
    ucpmClassification: 'Klasifikimi UCPM',
    icaoCode: 'Kodi ICAO',
    iataCode: 'Kodi IATA',
    noHubs: 'Nuk u gjetën nyje',
    confirmDelete: 'A jeni i sigurt që dëshironi ta fshini këtë nyje?',
    searchHubs: 'Kërko nyje...',
    nationAssignment: 'Caktimi i shteteve',
    assignNations: 'Cakto shtetet',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Institucionet shëndetësore',
    createFacility: 'Krijo institucion',
    editFacility: 'Ndrysho institucionin',
    deleteFacility: 'Fshi institucionin',
    facilityName: 'Emri i institucionit',
    facilityType: 'Lloji i institucionit',
    hospitalName: 'Emri i spitalit',
    bedCapacity: 'Kapaciteti i shtretërve',
    specialties: 'Specialitetet',
    availableBeds: 'Shtretërit e disponueshëm',
    totalBeds: 'Numri total i shtretërve',
    contactPerson: 'Personi i kontaktit',
    noFacilities: 'Nuk u gjetën institucione shëndetësore',
    confirmDelete: 'A jeni i sigurt që dëshironi ta fshini këtë institucion?',
    searchFacilities: 'Kërko institucione...',
    hubNationAssignment: 'Caktimi i shteteve në nyje',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Oraret',
    createSchedule: 'Krijo orar',
    editSchedule: 'Ndrysho orarin',
    deleteSchedule: 'Fshi orarin',
    scheduleName: 'Emri i orarit',
    scheduleType: 'Lloji i orarit',
    recurring: 'I përsëritshëm',
    oneTime: 'Njëherësh',
    frequency: 'Frekuenca',
    daily: 'Ditore',
    weekly: 'Javore',
    startDate: 'Data e fillimit',
    endDate: 'Data e përfundimit',
    departureTime: 'Ora e nisjes',
    arrivalTime: 'Ora e mbërritjes',
    stops: 'Ndalesat',
    addStop: 'Shto ndalesë',
    noSchedules: 'Nuk u gjetën orare',
    bookings: 'Rezervimet',
    timeline: 'Kronologjia',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Njoftimet',
    markAllRead: 'Shëno të gjitha si të lexuara',
    markAsRead: 'Shëno si të lexuar',
    markAsUnread: 'Shëno si të palexuar',
    noNotifications: 'Nuk ka njoftime',
    viewAll: 'Shiko të gjitha njoftimet',
    settings: 'Cilësimet e njoftimeve',
    emailNotifications: 'Njoftimet me e-postë',
    inAppNotifications: 'Njoftimet në aplikacion',
    notifyOn: 'Njoftomë për',
    requestCreated: 'Kërkesë e re',
    requestPublished: 'Kërkesë e publikuar',
    requestClosed: 'Kërkesë e mbyllur',
    requestCompleted: 'Kërkesë e përfunduar',
    commentAdded: 'Koment i ri',
    offerReceived: 'Ofertë e pranuar',
    offerAccepted: 'Ofertë e pranuar',
    statusChanged: 'Gjendja u ndryshua',
    selectionStarted: 'Përzgjedhja filloi',
    missionCreated: 'Transport i krijuar',
    missionStatusUpdated: 'Transport i përditësuar',
    transportPartnerNamed: 'Partneri i transportit',
    transportExtensionReceived: 'Zgjatje e transportit',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Cilësimet',
    general: 'Të përgjithshme',
    system: 'Sistemi',
    email: 'E-posta',
    sync: 'Sinkronizimi',
    security: 'Siguria',
    appearance: 'Pamja',
    systemName: 'Emri i sistemit',
    systemEmail: 'E-posta e sistemit',
    maintenanceMode: 'Mënyra e mirëmbajtjes',
    readOnlyMode: 'Mënyra vetëm lexim',
    emailEnabled: 'E-posta e aktivizuar',
    smtpHost: 'Serveri SMTP',
    smtpPort: 'Porta SMTP',
    smtpUser: 'Përdoruesi SMTP',
    smtpPassword: 'Fjalëkalimi SMTP',
    senderEmail: 'E-posta e dërguesit',
    senderName: 'Emri i dërguesit',
    testEmail: 'Dërgo e-postë testuese',
    syncEnabled: 'Sinkronizimi i aktivizuar',
    syncUrl: 'URL e sinkronizimit',
    syncApiKey: 'Çelësi API i sinkronizimit',
    settingsSaved: 'Cilësimet u ruajtën me sukses',
    helpdesk: 'Shërbimi i ndihmës',
    helpdeskTitle: 'Titulli i shërbimit të ndihmës',
    helpdeskEmail: 'E-posta e shërbimit të ndihmës',
    helpdeskPhone: 'Telefoni i shërbimit të ndihmës',
    helpdeskInfo: 'Informacione për shërbimin e ndihmës',
    realLifeSupport: 'Mbështetja në jetën reale',
    trainingMode: 'Mënyra e stërvitjes',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Regjistri i auditimit',
    action: 'Veprimi',
    user: 'Përdoruesi',
    target: 'Objektivi',
    details: 'Detajet',
    timestamp: 'Vula kohore',
    ipAddress: 'Adresa IP',
    noLogs: 'Nuk u gjetën regjistrime auditimi',
    searchLogs: 'Kërko regjistrime...',
    filterByAction: 'Filtro sipas veprimit',
    filterByUser: 'Filtro sipas përdoruesit',
    exportLogs: 'Eksporto regjistrimet',
    exportCsv: 'Eksporto CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Kontrolli i ushtimit',
    currentDay: 'Dita aktuale',
    exerciseDay: 'Dita e ushtimit',
    nextDay: 'Dita tjetër',
    previousDay: 'Dita e mëparshme',
    resetExercise: 'Rivendos ushtrimin',
    startExercise: 'Fillo ushtrimin',
    endExercise: 'Përfundo ushtrimin',
    dayReset: 'Rivendosja e ditës',
    confirmReset: 'A jeni i sigurt që dëshironi të rivendosni ditën e ushtimit? Kjo do të fshijë të gjitha të dhënat për ditën aktuale.',
    resetInProgress: 'Rivendosja në vazhdim...',
    maintenanceMode: 'Mënyra e mirëmbajtjes',
    enableMaintenance: 'Aktivizo mirëmbajtjen',
    disableMaintenance: 'Çaktivizo mirëmbajtjen',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Sinkronizimi i të dhënave',
    syncStatus: 'Gjendja e sinkronizimit',
    lastSync: 'Sinkronizimi i fundit',
    pendingItems: 'Artikujt në pritje',
    syncNow: 'Sinkronizo tani',
    syncing: 'Po sinkronizohet...',
    syncSuccess: 'Sinkronizimi përfundoi me sukses',
    syncFailed: 'Sinkronizimi dështoi',
    outbox: 'Kutia dalëse',
    inbox: 'Kutia hyrëse',
    configuration: 'Konfigurimi',
    targetUrl: 'URL e destinacionit',
    apiKey: 'Çelësi API',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Harta',
    layers: 'Shtresat',
    requests: 'Kërkesat',
    hubs: 'Nyjet',
    facilities: 'Institucionet',
    routes: 'Rrugët',
    showAll: 'Shfaq të gjitha',
    hideAll: 'Fshih të gjitha',
    zoomIn: 'Zmadho',
    zoomOut: 'Zvogëlo',
    resetView: 'Rivendos pamjen',
    satellite: 'Satelitor',
    terrain: 'Terren',
    offline: 'Jashtë linje',
    online: 'Në linjë',
    tilesOffline: 'Pllakat e hartës shërbehet lokalisht',
    tilesOnline: 'Pllakat e hartës ngarkohen nga serverët në linjë',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistikat',
    overview: 'Pasqyrë',
    requestsByStatus: 'Kërkesat sipas gjendjes',
    requestsByCategory: 'Kërkesat sipas kategorisë',
    requestsByNation: 'Kërkesat sipas shtetit',
    offersByStatus: 'Ofertat sipas gjendjes',
    patientsByCondition: 'Pacientët sipas gjendjes',
    transportsByStatus: 'Transportet sipas gjendjes',
    timeline: 'Kronologjia',
    totalRequests: 'Numri total i kërkesave',
    totalOffers: 'Numri total i ofertave',
    totalPatients: 'Numri total i pacientëve',
    totalTransports: 'Numri total i transporteve',
    averageResponseTime: 'Koha mesatare e përgjigjes',
    completionRate: 'Shkalla e përfundimit',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Statistikat e ushtimit',
    overview: 'Pasqyrë',
    byCategory: 'Sipas kategorisë',
    byNation: 'Sipas shtetit',
    byDay: 'Sipas ditës',
    totalPatientsMoved: 'Numri total i pacientëve të transportuar',
    totalRequestsProcessed: 'Numri total i kërkesave të përpunuara',
    averageProcessingTime: 'Koha mesatare e përpunimit',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Diagrami i rrjedhës',
    sankey: 'Sankey',
    nodeGraph: 'Grafi i nyjeve',
    refresh: 'Rifresko',
    noData: 'Nuk ka të dhëna rrjedhe të disponueshme',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Rreth sistemit',
    version: 'Versioni',
    systemInfo: 'Informacione mbi sistemin',
    buildDate: 'Data e ndërtimit',
    environment: 'Mjedisi',
    description: 'ARCOS — Sistemi i avancuar i komunikimit të kërkesave',
    subtitle: 'Ndihma për viktimat dhe operacionet mjekësore',
    whatIsArcos: 'Çfarë është ARCOS? – Shpjegim për pjesëmarrësit e stërvitjes',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Mbështetur nga MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – ku kurioziteti takon bashkëpunimin.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentacioni',
    gettingStarted: 'Fillimi',
    userGuide: 'Udhëzuesi i përdoruesit',
    faq: 'Pyetjet e shpeshta',
    troubleshooting: 'Zgjidhja e problemeve',
    apiReference: 'Referenca API',
    downloadTemplate: 'Shkarko shabllon',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Importi i pacientëve',
    uploadFile: 'Ngarko skedarin',
    selectFile: 'Zgjidh skedarin',
    preview: 'Paraparje',
    importNow: 'Importo tani',
    importing: 'Po importohet...',
    importSuccess: '{{count}} pacientë u importuan me sukses',
    importFailed: 'Importi dështoi',
    downloadTemplate: 'Shkarko shabllon',
    dragDrop: 'Tërhiqni dhe lëshoni një skedar këtu, ose klikoni për të zgjedhur',
    supportedFormats: 'Formatet e mbështetura: XLSX, XLS, CSV',
    rowsFound: '{{count}} rreshta u gjetën',
    validRows: '{{count}} rreshta të vlefshëm',
    invalidRows: '{{count}} rreshta të pavlefshëm',
    duplicateRows: '{{count}} rreshta të dyfishuar',
    previewData: 'Paraparje e të dhënave',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Planifikimi i transportit',
    planRoute: 'Planifiko itinerarin',
    routeBuilder: 'Ndërtuesi i itinerarit',
    addWaypoint: 'Shto pikë ndërmjetme',
    removeWaypoint: 'Hiq pikën ndërmjetme',
    estimatedDuration: 'Kohëzgjatja e parashikuar',
    distance: 'Distanca',
    selectVehicle: 'Zgjidh mjetin',
  },

  transportBooking: {
    title: 'Rezervimi i transportit',
    bookTransport: 'Rezervo transport',
    availableSlots: 'Hapësirat e disponueshme',
    bookingConfirmed: 'Rezervimi u konfirmua',
    cancelBooking: 'Anulo rezervimin',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Planifikimi i kapacitetit',
    totalCapacity: 'Kapaciteti total',
    usedCapacity: 'Kapaciteti i përdorur',
    availableCapacity: 'Kapaciteti i disponueshëm',
    utilizationRate: 'Shkalla e shfrytëzimit',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Shabllonet e mjeteve',
    dayTemplates: 'Shabllonet ditore',
    createTemplate: 'Krijo shabllon',
    editTemplate: 'Ndrysho shabllon',
    deleteTemplate: 'Fshi shabllon',
    templateName: 'Emri i shabllon',
    applyTemplate: 'Zbato shabllon',
    noTemplates: 'Nuk u gjetën shabllone',
    confirmDelete: 'A jeni i sigurt që dëshironi ta fshini këtë shabllon?',
    confirmApply: 'A jeni i sigurt që dëshironi ta zbatoni këtë shabllon? Kjo do të mbishkruajë të dhënat ekzistuese.',
    exportTemplates: 'Eksporto shabllonet',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Shiriti i njoftimeve',
    createAnnouncement: 'Krijo njoftim',
    editAnnouncement: 'Ndrysho njoftimin',
    deleteAnnouncement: 'Fshi njoftimin',
    message: 'Mesazhi',
    startTime: 'Ora e fillimit',
    endTime: 'Ora e përfundimit',
    active: 'Aktiv',
    noAnnouncements: 'Nuk ka njoftimet',
    confirmDelete: 'A jeni i sigurt që dëshironi ta fshini këtë njoftim?',
  },

  // ============================================================
  // COMPONENTS — Vargjet e komponentëve të ripërdorshëm
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Kërko...',
      noResults: 'Nuk u gjetën rezultate',
      showing: 'Po shfaqet {{from}} deri {{to}} nga {{total}}',
      rowsPerPage: 'Rreshta për faqe',
      previousPage: 'Faqja e mëparshme',
      nextPage: 'Faqja tjetër',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Konfirmo',
      cancel: 'Anulo',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Ndryshime të paruajtura',
      message: 'Keni ndryshime të paruajtura. A jeni i sigurt që dëshironi të largoheni nga kjo faqe?',
      stay: 'Qëndro në faqe',
      leave: 'Largohu nga faqja',
    },
    // EmptyState
    emptyState: {
      noData: 'Nuk ka të dhëna të disponueshme',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Diçka shkoi keq',
      message: 'Ndodhi një gabim i papritur. Ju lutem provoni të rifreskoni faqen.',
      retry: 'Provo përsëri',
    },
    // ExportButton
    exportButton: {
      export: 'Eksporto',
      exporting: 'Po eksportohet...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Printo',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Draft',
      review: 'Shqyrtim',
      published: 'Publikuar',
      selection: 'Përzgjedhje',
      inTransit: 'Në transport',
      completed: 'Përfunduar',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Instanca në linjë',
      message: 'Mënyra vetëm lexim. Të dhënat sinkronizohen nga serveri kryesor.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Po shikoni si',
      loggedInAs: 'i hyrë si {{nation}}',
      returnTo: 'Kthehu te {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Kërko faqe, kërkesa, transportë...',
      searching: 'Po kërkohet...',
      noResults: 'Nuk ka rezultate për "{{query}}"',
      navigate: 'Navigo',
      select: 'Zgjidh',
      close: 'Mbyll',
      pages: {
        dashboard: 'Paneli kryesor',
        requests: 'Kërkesat',
        transports: 'Transportet',
        map: 'Harta',
        myPatients: 'Pacientët e mi',
        flowDiagram: 'Diagrami i rrjedhës',
        statistics: 'Statistikat',
        assets: 'Mjetet',
        startPoints: 'Pikat e nisjes / Nyjet',
        treatmentFacilities: 'Institucionet shëndetësore',
        users: 'Përdoruesit',
        settings: 'Cilësimet',
        auditLogs: 'Regjistri i auditimit',
        exerciseControl: 'Kontrolli i ushtimit',
        dataSync: 'Sinkronizimi i të dhënave',
        patientImport: 'Importi i pacientëve',
        notifications: 'Njoftimet',
        documentation: 'Dokumentacioni',
      },
      actions: {
        importPatientsJson: 'Importo Pacientët (JSON)',
        importPatientsExcel: 'Importo Pacientët (Excel)',
        importUsers: 'Importo Përdoruesit (Excel)',
        importAssetTemplates: 'Importo Modelet e aseteve (Excel)',
        importDayTemplates: 'Importo Hyrjet e modelit ditor (Excel)',
        exportRequests: 'Eksporto Kërkesat (Excel)',
        exportPatients: 'Eksporto Pacientët (Excel)',
        exportUsers: 'Eksporto Përdoruesit (Excel)',
        exportCredentials: 'Eksporto Kredencialet (PDF)',
        exportAuditExcel: 'Eksporto Regjistri i auditimit (Excel)',
        exportAuditPdf: 'Eksporto Regjistri i auditimit (PDF)',
        pagePatientImport: 'Faqja e importit të pacientëve',
        pageRequestDetail: 'Faqja e detajeve të kërkesës',
        pageUsers: 'Faqja e menaxhimit të përdoruesve',
        pageAssetTemplates: 'Faqja e modeleve të aseteve',
        pageDayTemplates: 'Faqja e modeleve ditore',
        pageRequests: 'Faqja e listës së kërkesave',
        pageAuditLogs: 'Faqja e regjistrit të auditimit',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sesioni po skadon',
      message: 'Sesioni juaj do të skadojë për <strong>{{time}}</strong>. Ju lutem ruani punën tuaj dhe hyni përsëri.',
      dismiss: 'Hiq',
      logoutNow: 'Dil tani',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Zgjidhni 4 zona kohore',
      configure: 'Konfiguro zonat kohore',
      reset: 'Rivendos',
      apply: 'Zbato',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Zgjidh vendndodhjen',
      latitude: 'Gjerësia gjeografike',
      longitude: 'Gjatësia gjeografike',
      clickToSelect: 'Klikoni në hartë për të zgjedhur një vendndodhje',
    },
    // Modal
    modal: {
      close: 'Mbyll',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Kryefaqja',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Mirëmbajtja e sistemit',
    message: 'Sistemi po rivendoset për ditën e ardhshme të ushtimit. Ju lutem prisni derisa procesi të përfundojë.',
    autoRefresh: 'Kjo faqe do të rifreskojë automatikisht kur sistemi të jetë i disponueshëm përsëri.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Të paktën 10 karaktere',
    uppercase: '1 shkronjë e madhe',
    lowercase: '1 shkronjë e vogël',
    digit: '1 shifër',
    special: '1 karakter special',
  },
};

export default sq;
